import { render, staticRenderFns } from "./editAllModule.vue?vue&type=template&id=23bfe1eb&scoped=true&"
import script from "./editAllModule.vue?vue&type=script&lang=js&"
export * from "./editAllModule.vue?vue&type=script&lang=js&"
import style0 from "./editAllModule.vue?vue&type=style&index=0&id=23bfe1eb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bfe1eb",
  null
  
)

export default component.exports